import React, { useEffect, useRef, useState } from "react";
import styles from "./Style.module.css";
import { EllipsisVertical } from "lucide-react";

const EditPaxDropdown = ({
  actions = [],
  triggerAriaLabel = "Open menu",
  className = "",
  showConnector = true,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleOutsideClick = (event) => {
      if (!menuRef.current?.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [isOpen]);

  const handleItemClick = (event, onClick) => {
    event.stopPropagation();
    setIsOpen(false);
    onClick?.();
  };

  return (
    <div className={`${styles.dropdown} ${className}`} ref={menuRef} data-edit-pax-dropdown>
      <button
        type="button"
        className={styles.trigger}
        aria-label={triggerAriaLabel}
        onClick={(event) => {
          event.stopPropagation();
          setIsOpen((prev) => !prev);
        }}
      >
        <EllipsisVertical size={20} color="var(--Neutral900)" />
      </button>

      {isOpen && actions.length > 0 ? (
        <div className={`${styles.menu} ${showConnector ? styles.withConnector : ""}`}>
          {actions.map((action) => {
            const isDanger = action.label === "Remove Guest";
            return (
              <button
                key={action.id ?? action.label}
                type="button"
                className={`${styles.menuItem} hover ${isDanger ? styles.danger : ""}`}
                onClick={(event) => handleItemClick(event, action.onClick)}
                title={action.label}
                aria-label={action.label}
              >
                {action.label}
              </button>
            )
          })}
        </div>
      ) : null}
    </div>
  );
};

export default EditPaxDropdown;